import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SeFeThemesLoader } from 'se-fe-themes';

@Component({
  selector: 'app-root',
  styleUrls: [],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent {
  public title = 'se-financial-admin-ui-library';
  constructor() {
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
  }
}
